import i18n from '../i18nService';
import { productNamesService } from './productNamesService';

export const productsService = {
    getLocalization(localeCode, productOrCode, withCodeReplace, i18nInstance = i18n) {
        return productNamesService.getLocalization(localeCode, productOrCode, withCodeReplace, i18nInstance);
    },
    getPlaceholder(i18nInstance = i18n) {
        return productNamesService.getPlaceholder(i18nInstance);
    },
};
